import dayjs from "@/lib/helpers/dayjs";

export type EncounterInitialValues = {
  delete_marker: boolean;
  discharge_date: string;
  discharge_type: string[];
  encounter_date: string;
  encounter_information: string;
  encounter_type: string[];
  setting: string[];
  setting_other: string;
};

export const ENCOUNTER_SCHEMA = (encounterIndex: number) => [
  {
    elementClasses: "col-12 col-lg-4",
    elementConfig: {
      label: "Encounter Date",
      placeholder: dayjs().format("MM/DD/YYYY"),
      type: "text",
    },
    elementType: "datePicker",
    inputClasses: "Input--sm",
    name: `content.encounters[${encounterIndex}].encounter_date`,
    relativeName: "encounter_date",
  },
  {
    elementClasses: "col-12 col-lg-4",
    elementConfig: {
      label: "Discharge Date (if applicable)",
      placeholder: dayjs().format("MM/DD/YYYY"),
      type: "text",
    },
    elementType: "datePicker",
    inputClasses: "Input--sm",
    name: `content.encounters[${encounterIndex}].discharge_date`,
    relativeName: "discharge_date",
  },
  {
    elementClasses: "col-6",
    elementConfig: {
      label: "Encounter Type",
      options: [
        { display: "Psychiatric", value: "Psychiatric" },
        { display: "Medical", value: "Medical" },
        { display: "SUD", value: "SUD" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    inputClasses: "Input--sm",
    name: `content.encounters[${encounterIndex}].encounter_type`,
    relativeName: "encounter_type",
  },
  {
    elementClasses: "col-6",
    elementConfig: {
      label: "Discharge Type (if applicable)",
      options: [
        { display: "Routine", value: "Routine" },
        { display: "AMA", value: "AMA" },
        { display: "Transfer", value: "Transfer" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    inputClasses: "Input--sm",
    name: `content.encounters[${encounterIndex}].discharge_type`,
    relativeName: "discharge_type",
  },
  {
    elementClasses: "col-12",
    elementConfig: {
      label: "Setting",
      options: [
        { display: "Emergency Room", value: "Emergency Room" },
        { display: "Urgent Care", value: "Urgent Care" },
        { display: "Hospital Admission", value: "Hospital Admission" },
        { display: "Crisis", value: "Crisis" },
        { display: "Other (open text)", openText: true, value: "Other (open text)" },
      ],
      type: "checkbox",
    },
    elementType: "input",
    inputClasses: "Input--sm",
    name: `content.encounters[${encounterIndex}].setting`,
    relativeName: "setting",
  },
  {
    elementClasses: "col-12",
    elementConfig: {
      label: "Encounter Information",
      placeholder: "Type Comment...",
      type: "textArea",
    },
    elementType: "textarea",
    name: `content.encounters[${encounterIndex}].encounter_information`,
  },
];
